import { render, staticRenderFns } from "./ConfirmView.vue?vue&type=template&id=c0ef51a2&scoped=true&"
import script from "./ConfirmView.vue?vue&type=script&lang=ts&"
export * from "./ConfirmView.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmView.vue?vue&type=style&index=0&id=c0ef51a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ef51a2",
  null
  
)

export default component.exports